var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useForceUpdate } from '../../lib/misc.functions';
import { availableLongtermHippodromes, DailyRaces, tjkBetSlipActionSubject, tjkBetSlipOptions, tjkBettingTypesMap, } from './tjk.store';
import { addToTjkLongtermBetSlip, isAddedLongterm } from './tjk.betslip.service';
import { getAvailableBettingTypes, getAvailableHippodromes, getDailyRaces } from './tjk.utils';
import iconAlert from '../../assets/feather/alert-circle.svg';
var refreshTimer = null;
var LongtermRaces = function () {
    var forceUpdate = useForceUpdate();
    var _a = useState(null), selectedHippodromeId = _a[0], setSelectedHippodromeId = _a[1];
    useEffect(function () {
        tjkBetSlipOptions.bettingType = tjkBettingTypesMap[1889];
        tjkBetSlipOptions.bettingSubType = '1';
        tjkBetSlipOptions.column = 1;
        tjkBetSlipOptions.betSlipMultiply = 20;
        if (DailyRaces.length === 0) {
            getDailyRaces().then(function () {
                getAvailableHippodromes();
                forceUpdate();
            });
        }
        refreshTimer = setInterval(function () {
            getDailyRaces().then(function () {
                getAvailableHippodromes();
                getAvailableBettingTypes();
                forceUpdate();
            });
        }, 5000);
        return function () {
            clearInterval(refreshTimer);
        };
    }, []);
    useEffect(function () {
        var sub = tjkBetSlipActionSubject.subscribe(function () { return forceUpdate(); });
        return function () { return sub.unsubscribe(); };
    }, []);
    useEffect(function () {
        if (availableLongtermHippodromes.length === 0)
            return;
        var stillVisible = availableLongtermHippodromes.find(function (h) { return h.id === selectedHippodromeId; });
        if (!stillVisible) {
            setSelectedHippodromeId(availableLongtermHippodromes[0].id);
        }
    }, [availableLongtermHippodromes.length]);
    var selectedHippodrome = availableLongtermHippodromes.find(function (h) { return h.id === selectedHippodromeId; }) ||
        availableLongtermHippodromes[0] ||
        null;
    tjkBetSlipOptions.hippodrome = selectedHippodrome;
    if (availableLongtermHippodromes.length === 0) {
        return (_jsx("div", __assign({ className: "col-12", style: { minHeight: '75vh' } }, { children: _jsxs("div", __assign({ className: "hint-text text-center p-5" }, { children: [_jsx("img", { src: iconAlert, className: "invert-color" }, void 0), _jsx("br", {}, void 0), _jsx("p", __assign({ className: "fs-6 mb-0 mt-2" }, { children: "Uzun vadeli at yar\u0131\u015F\u0131 b\u00FClteni bulunmamaktad\u0131r. B\u00FClten sisteme y\u00FCklendi\u011Finde bu alanda otomatik olarak g\u00F6r\u00FCnt\u00FClenecektir. L\u00FCtfen daha sonra tekrar kontrol ediniz." }), void 0)] }), void 0) }), void 0));
    }
    return (_jsxs(React.Fragment, { children: [_jsx("div", __assign({ className: "header" }, { children: _jsx("ul", __assign({ className: "locationtab hidden-sm w-100" }, { children: availableLongtermHippodromes.map(function (hippodrome, key) { return (_jsx("li", __assign({ className: 'cursor-pointer tjklocation ' +
                            ((selectedHippodrome === null || selectedHippodrome === void 0 ? void 0 : selectedHippodrome.id) === hippodrome.id ? 'activeTab ' : ''), onClick: function () { return setSelectedHippodromeId(hippodrome.id); } }, { children: hippodrome.hippodrome }), "longterm-tab-".concat(hippodrome.id || key))); }) }), void 0) }), void 0), _jsxs("div", __assign({ className: "runs" }, { children: [_jsxs("div", __assign({ className: "run-detail-header" }, { children: [_jsx("span", { children: selectedHippodrome.hippodrome }, void 0), selectedHippodrome.description && _jsx("span", { children: selectedHippodrome.description }, void 0)] }), void 0), _jsx("div", __assign({ className: "long-term-races-mobile" }, { children: Object.values(selectedHippodrome.event_odds || {}).map(function (odd) {
                            var isSelected = isAddedLongterm(selectedHippodrome, odd) !== false;
                            var isLocked = odd.status !== 'o';
                            return (_jsxs("div", __assign({ className: "long-term-races-horse-card".concat(isSelected ? ' added' : '').concat(isLocked ? ' kosmaz-card' : ''), onClick: function () { return !isLocked && addToTjkLongtermBetSlip(selectedHippodrome, odd, 'toggle'); } }, { children: [_jsx("div", __assign({ className: "races-horse-name-cell", style: { fontSize: "15px" } }, { children: odd.description }), void 0), _jsx("div", __assign({ className: "btn-odds fob-odds-btn added-".concat(isSelected) }, { children: _jsx("span", __assign({ className: "ratio" }, { children: isLocked ? 'K' : (odd.win_odds > 1 ? Number(odd.win_odds).toFixed(2) : '-') }), void 0) }), void 0)] }), "longterm-odd-".concat(selectedHippodrome.id, "-").concat(odd.no)));
                        }) }), void 0)] }), void 0)] }, void 0));
};
export default LongtermRaces;
